import script from "./LocationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocationForm.vue?vue&type=script&lang=ts&setup=true"

import "./LocationForm.vue?vue&type=style&index=0&id=0d069a02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d069a02"]])

export default __exports__